import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmailAttemptDto, EmailAttemptStatus, EmailTriggers } from '@workspace/data-types';
import { CodeBlockComponent, LuxonDatePipe } from '@workspace/ng-aura';
import { EmailAttemptStatusDisplayPipe, EmailTriggerDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'core-email-attempts',
  templateUrl: './email-attempts.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatTooltipModule,
    CodeBlockComponent,
    LuxonDatePipe,
    EmailAttemptStatusDisplayPipe,
    EmailTriggerDisplayPipe,
  ],
})
export class EmailAttemptsCoreComponent {
  attempts = input.required<EmailAttemptDto[]>();

  readonly emailAttemptStatus = EmailAttemptStatus;
  readonly emailTriggers = EmailTriggers;
}
